import analytics from './utils/ga'
import SearchForm from './components/SearchForm'
import Loader from './components/Loader'
import SearchResult from './components/SearchResult'
import SearchResultMultiple from './components/SearchResultMultiple'
import ErrorMessage from './components/ErrorMessage'
import Vue from 'vue'

if (document.querySelector('#search')) {
    new Vue({
        el: '#search',
        components: {
            SearchForm,
            Loader,
            SearchResult,
            SearchResultMultiple,
            ErrorMessage
        },
        created() {
            this.$root.$on('input-inserted', () => {
                analytics.inputInserted();
            })
            this.$root.$on('search-started', (typeSubmit) => {
                analytics.searchStarted(typeSubmit);
            })
            this.$root.$on('error-occured', (error, message) => {
                analytics.errorOccured(message || error);
            })
            this.$root.$on('tt-result-received', () => {
                analytics.resultReceived();
            })
            this.$root.$on('download-click', (type) => {
                analytics.sendDownloadFormat(type);
            })
        },
    })
}
